export const strings = {
    prefixAgo: null,
    prefixFromNow: null,
    suffixAgo: '',
    suffixFromNow: '',
    seconds: '1دقیقه',
    minute: '1دقیقه',
    minutes: '%dدقیقه',
    hour: '1ساعت',
    hours: '%dساعت',
    day: '1روز',
    days: '%dروز',
    month: '1ماه',
    months: '%dماه',
    year: '1سال',
    years: '%dسال',
    wordSeparator: ' ',
};
